module.exports = __webpack_public_path__ + "media/images/placeholders/user-4d7853bec04e8d1e11569e61f6d010d4.png";